import AnalyticsService from "@pency/api/analytics";

export default new AnalyticsService(process.env.GA_TRACKING);
